<div class="lg:border lg:border-gray-200 rounded-md shadow-md bg-white lg:p-4 md:h-full">
    <ng-content></ng-content>
</div>
